import { render } from "./SurveyView.vue?vue&type=template&id=3e9721e9&scoped=true"
import script from "./SurveyView.vue?vue&type=script&lang=ts"
export * from "./SurveyView.vue?vue&type=script&lang=ts"

import "./SurveyView.vue?vue&type=style&index=0&id=3e9721e9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e9721e9"

export default script